import { get, post, remove } from '@airasia-common/libraries/http/hotelRequest';

const BASE_URL = '/booking';

export const getPrecancellationData = href => () => get(`${BASE_URL}${href}`);

export const cancelBooking = (href, { reason, refund }) => () =>
  remove(`${BASE_URL}${href}`, { reason, refund });

const SEND_VOUCHER_SUCCESS_CODE = 204;

export const sendVoucher = (sendVoucherHref, email) =>
  post(`${BASE_URL}${sendVoucherHref}`, { email }).then(response => {
    if (response.status !== SEND_VOUCHER_SUCCESS_CODE) {
      return Promise.reject(response);
    }

    return response;
  });
